import SelectField from 'components/forms/selectField/SelectField';
import StarRatingField from 'components/forms/starRatingField/StarRatingField';
import TextField from 'components/forms/textField/TextField';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import RichTextEditorField from 'components/forms/richTextEditor/RichTextEditorField';
import { RichTextEditorToolbarPluginProps } from 'components/editor/RichTextEditor.types';
import TextAreaField from 'components/forms/textAreaField/TextAreaField';
import {
  ReviewCategoriesCollapse,
  ReviewTemplateModalContentContainer,
} from './AddEditReviewTemplateModal.styles';

const ReviewTemplateModalContent = ({
  hideFieldsForVrbo,
}: {
  hideFieldsForVrbo: boolean;
}) => {
  const { t } = useTranslation();

  const toolbarSettings: RichTextEditorToolbarPluginProps['toolbarSettings'] = {
    enabled: true,
    features: {
      variables: [
        {
          value: '[$GUEST_FIRST_NAME$]',
          label: t('form.editor.variables.GUEST_FIRST_NAME'),
        },
      ],
    },
  };

  return (
    <ReviewTemplateModalContentContainer>
      {!hideFieldsForVrbo && (
        <TextField
          colSmInput={8}
          colSmLabel={4}
          required
          name="title"
          label={t(
            'pageAutomations.reviews.guestReviewTemplates.modal.reviewTitle',
          )}
        />
      )}
      <StarRatingField
        colSmInput={8}
        colSmLabel={4}
        required
        name="rate"
        label={t(
          'pageAutomations.reviews.guestReviewTemplates.modal.overallRating',
        )}
      />
      <ReviewCategoriesCollapse
        defaultExpanded
        variant="card"
        label={t(
          'pageAutomations.reviews.guestReviewTemplates.modal.reviewCategories',
        )}
        labelInfoTooltip={t(
          'pageAutomations.reviews.guestReviewTemplates.modal.worksWithAirbnbOnly',
        )}
      >
        <Row>
          <Col xs={12} sm={6}>
            <StarRatingField
              labelOnTop
              required
              name="cleanliness"
              label={t(
                'pageAutomations.reviews.guestReviewTemplates.modal.cleanliness',
              )}
            />
          </Col>
          <Col xs={12} sm={6}>
            <StarRatingField
              labelOnTop
              required
              name="communication"
              label={t(
                'pageAutomations.reviews.guestReviewTemplates.modal.communication',
              )}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={6}>
            <StarRatingField
              labelOnTop
              required
              name="respectHouseRules"
              label={t(
                'pageAutomations.reviews.guestReviewTemplates.modal.respectHouseRules',
              )}
            />
          </Col>
          <Col xs={12} sm={6}>
            <SelectField
              labelOnTop
              required
              colXsInput={6}
              name="isGuestRecommended"
              label={t(
                'pageAutomations.reviews.guestReviewTemplates.modal.isGuestRecommended',
              )}
              options={[
                { label: t('common.yes'), value: 'yes' },
                { label: t('common.no'), value: 'no' },
              ]}
            />
          </Col>
        </Row>
      </ReviewCategoriesCollapse>
      {!hideFieldsForVrbo && (
        <>
          <RichTextEditorField
            colSmInput={12}
            label={t(
              'pageAutomations.reviews.guestReviewTemplates.modal.reviewContent',
            )}
            labelOnTop
            labelTooltip={t(
              'pageAutomations.reviews.guestReviewTemplates.modal.worksWithAirbnbOnly',
            )}
            linkMode="edit"
            name="content"
            toolbarSettings={toolbarSettings}
            required
            stripHTML
          />
          <TextAreaField
            label={t(
              'pageAutomations.reviews.guestReviewTemplates.modal.privateFeedback',
            )}
            colSmInput={12}
            labelTooltip={t(
              'pageAutomations.reviews.guestReviewTemplates.modal.worksWithAirbnbOnly',
            )}
            name="privateFeedback"
            rows={3}
            labelOnTop
          />
        </>
      )}
    </ReviewTemplateModalContentContainer>
  );
};

export default ReviewTemplateModalContent;
